<template>
  <div class="home-carousel" v-if="courses && courses.length > 0">
    <t-swiper
      class="carousel-swiper"
      :autoplay="true"
      :interval="4000"
      animation="slide"
      :navigation="{ type: 'dots-bar', showSlideBtn: 'always' }"
      :height="375"
    >
      <t-swiper-item v-for="(item, index) in courses" :key="item.courseId || index">
        <div class="carousel-slide" @click="goDetail(item.courseId)">
          <img :src="item.coverUrl" height="375" :alt="item.title" style="width: 100%; object-fit: cover;" />
          <div class="carousel-info">
            <p class="carousel-title">{{item.title}}</p>
            <p class="carousel-meta">
              <span v-if="item.learningCount > 0">{{item.learningCount}}人学习</span>
              <span v-if="item.avgRating > 0" class="carousel-rating">{{item.avgRating}}分</span>
            </p>
          </div>
        </div>
      </t-swiper-item>
    </t-swiper>
  </div>
</template>

<script>
export default {
  name: 'HomeCarousel',
  props: {
    courses: {
      type: Array,
      default: () => []
    }
  },
  emits: ['select'],
  methods: {
    goDetail (courseId) {
      if (!courseId) return
      this.$emit('select', courseId)
      this.$router.push({
        name: 'CourseDetail',
        params: {
          target: this.$store.state.sessionTarget,
          courseId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-carousel {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  .carousel-swiper {
    border-radius: 8px;
  }

  .carousel-slide {
    position: relative;
    cursor: pointer;
    height: 375px;

    .carousel-info {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: linear-gradient(transparent, rgba(0,0,0,0.7));
      padding: 40px 20px 16px;
      color: #fff;

      .carousel-title {
        font-size: 18px;
        font-weight: 600;
        margin: 0 0 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .carousel-meta {
        font-size: 13px;
        color: rgba(255,255,255,0.85);
        display: flex;
        gap: 16px;

        .carousel-rating {
          color: #FFD700;
        }
      }
    }
  }

  :deep(.t-swiper__navigation) {
    .t-swiper__btn,
    .t-swiper__navigation-item {
      color: #fff !important;
      border-radius: 50% !important;
      width: 36px !important;
      height: 36px !important;
      &:hover {
  
      }
    }
  }
  :deep(.t-swiper__arrow) {
    color: #fff !important;
    border-radius: 50%;
    &:hover {
      
    }
  }
}
</style>
